import React, { useEffect, useState } from "react";
import BenefitsMemberBanner from "../components/benefitsmember/BenefitsMemberBanner";
import { useLoader } from "../context/LoaderContext";
import {
  IBannerData,
  // IBenefitsMemberFromData,
  IBenefitsMemberTabData,
} from "../exports/interfaces";
import {
  fetchBenefitsMemberBanner,
  // fetchBenefitsMemberFrom,
  fetchBenefitsMemberTabs,
} from "../api/MemberApi";
import { dynamicFailed } from "../hooks/useToast";

// import BenefitsMemberFrom from "../components/benefitsmember/BenefitsMemberFrom";
import BenefitsMemberTab from "../components/benefitsmember/BenefitsMemberTab";
import { Link } from "react-router-dom";
import { useUserDataContext } from "../context/UserDataContext";

const BenefitsMember = () => {
  const { setLoading } = useLoader();
  const { userData } = useUserDataContext();
  const [benefitsMememberBannerData, setBenefitsMememberBannerData] = useState<
    IBannerData[]
  >([]);
  // const [benefitsMemberData, setBenefitsMemberData] = useState<
  //   IBenefitsMemberFromData[]
  // >([]);
  const [benefitsMemberTabData, setBenefitsMemberTabData] = useState<
    IBenefitsMemberTabData[]
  >([]);

  useEffect(() => {
    setLoading(true);
    Promise.all([
      fetchBenefitsMemberBanner(),
      // fetchBenefitsMemberFrom(),
      fetchBenefitsMemberTabs(),
    ])
      .then(
        ([
          benefitsMemberBannerData,
          // benefitsMemberFromData,
          benefitsMemberTabData,
        ]) => {
          setBenefitsMememberBannerData(benefitsMemberBannerData);
          // setBenefitsMemberData(benefitsMemberFromData);
          setBenefitsMemberTabData(benefitsMemberTabData);
          setTimeout(() => {
            setLoading(false);
          }, 1000);
        }
      )
      .catch(() => {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
        dynamicFailed("Server Error");
      });
  }, [benefitsMememberBannerData.length, setLoading]);
  return (
    <>
      <BenefitsMemberBanner
        benefitsMememberBannerData={benefitsMememberBannerData}
      />
      {/* <BenefitsMemberFrom benefitsMemberData={benefitsMemberData} /> */}
      <BenefitsMemberTab benefitsMemberTabData={benefitsMemberTabData} />
      {!userData && (
        <div style={{ paddingBottom: "90px", marginTop: "-55px" }}>
          <div className="container">
            <div className="row">
              <div className="col-xl-12">
                <Link
                  to="/become-a-member"
                  className="thm-btn main-header-two__btn custom-donate-btn"
                  style={{ paddingLeft: "5px" }}
                >
                  <i className="icon-user-plus"></i>
                  Become a Member
                </Link>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default BenefitsMember;
